import _system from '../../../libs/system'

export const removeChannel = {
    data() {
        return {}
    },
    methods: {
        deleteChannel(pageId){

            console.log(pageId)

            let once = false;

            let getAdminsAccounts = _.filter(this.workspaceusers, (workspaceuser) => {
                if(workspaceuser.tags.includes(this.tagsByName['Admin']._id)) return workspaceuser
            });
    
            for (const workspaceUser of getAdminsAccounts) {

                let payload = {
                    query: {
                        workspaceUsersId: workspaceUser._id,
                        pageId:pageId
                    }
                }
                _system.services.accounts.del(payload, (err, workspaceUser) => {
                    if(err) return alert(err.message);
                    if(!once){
                        let index = _.findIndex(this.accounts, {_id: pageId});
                        let i = _.findIndex(this.pages, {_id: pageId});
                        this.removeChannel(index);
                        this.pages.splice(i,1);
                        once = true;
                    }
                    
                });

            }
        }
    }

}


// WEBPACK FOOTER //
// ./src/components/dashboard/mixins/removeChannel.js